import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { getBundle, tKey, LANGUAGES } from "@/i18n/bundles";
import { useAuth } from "@/context/AuthContext";

const I18nCtx = createContext(null);

const STORAGE_KEY = "manodayam.lang";

export function I18nProvider({ children }) {
  const { user } = useAuth();
  const [lang, setLangState] = useState(() => {
    return localStorage.getItem(STORAGE_KEY) || "en";
  });

  useEffect(() => {
    // On login, prefer user's saved preferred language once
    if (user && user.preferred_language && !localStorage.getItem(STORAGE_KEY)) {
      setLangState(user.preferred_language);
      localStorage.setItem(STORAGE_KEY, user.preferred_language);
    }
  }, [user]);

  const setLang = useCallback((code) => {
    setLangState(code);
    localStorage.setItem(STORAGE_KEY, code);
  }, []);

  const t = useCallback((k) => tKey(lang, k), [lang]);

  return (
    <I18nCtx.Provider value={{ lang, setLang, t, languages: LANGUAGES, bundle: getBundle(lang) }}>
      {children}
    </I18nCtx.Provider>
  );
}

export const useI18n = () => useContext(I18nCtx);
